import ReactGA from 'react-ga4';
import { APP_GOOGLE_ANALYTICS_ENABLED } from './constants';
import { UaEventOptions } from 'react-ga4/types/ga4';

export const handleSendEvent = (args: UaEventOptions) => {
  if (APP_GOOGLE_ANALYTICS_ENABLED) {
    ReactGA.event(args);
  }    
}
